(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-selector-standalone"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  var currencies = [
    {code:'PLN',flag:'pl'},{code:'USD',flag:'us'},{code:'EUR',flag:'eu'},
    {code:'CZK',flag:'cz'},{code:'GBP',flag:'gb'},{code:'AUD',flag:'au'},
    {code:'CAD',flag:'ca'},{code:'SEK',flag:'se'},{code:'RON',flag:'ro'},
    {code:'CHF',flag:'ch'},{code:'NOK',flag:'no'}
  ];
  function flagUrl(flag) {
    return 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/flags/4x3/' + flag + '.svg';
  }
  function activeCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
  }
  function currencyName(code) {
    try {
      return new Intl.DisplayNames(
        [(document.documentElement.lang || 'pl').slice(0,2)],
        {type:'currency'}
      ).of(code) || code;
    } catch (error) {
      return code;
    }
  }
  function currencyHref(code) {
    try {
      var url = new URL(location.href);
      url.searchParams.set('currency', code);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '?currency=' + code;
    }
  }
  function close(root) {
    root.classList.remove('is-open');
    root.querySelector('[data-ccy-toggle]').setAttribute('aria-expanded','false');
  }
  function initRoot(root) {
    if (root.dataset.ccyInit === '1') return;
    root.dataset.ccyInit = '1';
    var current = activeCode();
    root.querySelector('[data-ccy-current]').textContent = current;
    var options = root.querySelector('[data-ccy-options]');
    currencies.forEach(function(currency) {
      var link = document.createElement('a');
      link.className = 'sps-ccy__opt' + (currency.code === current ? ' is-active' : '');
      link.href = currencyHref(currency.code);
      link.setAttribute('role','option');
      link.setAttribute('aria-selected',currency.code === current ? 'true' : 'false');
      var flag = document.createElement('span');
      flag.className = 'sps-ccy__opt-flag';
      var image = document.createElement('img');
      image.src = flagUrl(currency.flag);
      image.width = 20;
      image.height = 14;
      image.alt = '';
      flag.appendChild(image);
      var code = document.createElement('span');
      code.className = 'sps-ccy__opt-code';
      code.textContent = currency.code;
      var name = document.createElement('span');
      name.className = 'sps-ccy__opt-name';
      name.textContent = currencyName(currency.code);
      link.appendChild(flag);
      link.appendChild(code);
      link.appendChild(name);
      options.appendChild(link);
    });
    var button = root.querySelector('[data-ccy-toggle]');
    button.addEventListener('click', function(event) {
      event.stopPropagation();
      var opening = !root.classList.contains('is-open');
      document.querySelectorAll('[data-ccy-root].is-open').forEach(function(other) {
        if (other !== root) close(other);
      });
      root.classList.toggle('is-open', opening);
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
  }
  function init() {
    document.querySelectorAll('[data-ccy-root]').forEach(initRoot);
    document.addEventListener('click', function(event) {
      document.querySelectorAll('[data-ccy-root].is-open').forEach(function(root) {
        if (!root.contains(event.target)) close(root);
      });
    });
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-ccy-root].is-open').forEach(close);
      }
    });
    try {
      var url = new URL(location.href);
      if (url.searchParams.has('currency')) {
        url.searchParams.delete('currency');
        history.replaceState({},'',url.pathname + url.search + url.hash);
      }
    } catch (error) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector-standalone"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  var languages = {
    pl:{name:'Polski',flag:'pl'},
    en:{name:'English',flag:'gb'},
    ru:{name:'Русский',flag:'ru'},
    de:{name:'Deutsch',flag:'de'},
    cs:{name:'Čeština',flag:'cz'}
  };

  function populate(root) {
    if (root.dataset.languageInit === '1') return;
    root.dataset.languageInit = '1';
    var list = root.querySelector('[data-language-list]');
    if (!list) return;
    var alternatives = {};
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function(link) {
      var hreflang = (link.getAttribute('hreflang') || '').toLowerCase();
      var code = hreflang.split('-')[0];
      if (languages[code]) alternatives[code] = link.href;
      if (hreflang === 'x-default') alternatives.pl = link.href;
    });
    if (!Object.keys(alternatives).length) {
      Object.keys(languages).forEach(function(code) {
        alternatives[code] = code === 'pl' ? location.origin : location.origin + '/' + code;
      });
    }
    var current = (document.documentElement.lang || 'pl').slice(0,2).toLowerCase();
    Object.keys(languages).forEach(function(code) {
      if (!alternatives[code]) return;
      var link = document.createElement('a');
      link.href = alternatives[code];
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', code === current ? 'true' : 'false');
      if (code === current) link.className = 'is-active';
      var image = document.createElement('img');
      image.src = 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/flags/4x3/' + languages[code].flag + '.svg';
      image.width = 18;
      image.height = 12;
      image.alt = '';
      var text = document.createElement('span');
      text.textContent = languages[code].name;
      link.appendChild(image);
      link.appendChild(text);
      list.appendChild(link);
    });
    var button = root.querySelector('[data-language-toggle]');
    button.addEventListener('click', function(event) {
      event.stopPropagation();
      var opening = !root.classList.contains('is-open');
      document.querySelectorAll('[data-language-root].is-open').forEach(function(other) {
        other.classList.remove('is-open');
        other.querySelector('[data-language-toggle]').setAttribute('aria-expanded','false');
      });
      root.classList.toggle('is-open', opening);
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('[data-language-root]').forEach(populate);
    document.addEventListener('click', function(event) {
      document.querySelectorAll('[data-language-root].is-open').forEach(function(root) {
        if (!root.contains(event.target)) {
          root.classList.remove('is-open');
          root.querySelector('[data-language-toggle]').setAttribute('aria-expanded','false');
        }
      });
    });
    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-language-root].is-open').forEach(function(root) {
        root.classList.remove('is-open');
        root.querySelector('[data-language-toggle]').setAttribute('aria-expanded','false');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav-apple"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';

  var nav = document.querySelector('[data-sap-mobile-nav]');
  if (!nav) return;

  function directChild(element, className) {
    for (var i = 0; i < element.children.length; i++) {
      if (element.children[i].classList.contains(className)) return element.children[i];
    }
    return null;
  }

  function mobileLink(source, className) {
    var link = document.createElement('a');
    link.className = className;
    link.href = source.href;
    link.textContent = source.textContent.trim();
    return link;
  }

  function appendGroup(list, links, className, addSeparator) {
    if (!links.length) return false;
    if (addSeparator) {
      var separator = document.createElement('li');
      separator.className = 'sap-mobile-nav__separator';
      list.appendChild(separator);
    }
    for (var i = 0; i < links.length; i++) {
      var item = document.createElement('li');
      item.appendChild(mobileLink(links[i], className));
      list.appendChild(item);
    }
    return true;
  }

  function hydrateMenu() {
    if (nav.dataset.sapMenuHydrated === '1') return;
    var target = nav.querySelector('[data-sap-mobile-menu-list]');
    var source = document.querySelector('[data-sap-nav] > .sap-nav__list');
    if (!target || !source) return;

    for (var i = 0; i < source.children.length; i++) {
      var desktopItem = source.children[i];
      if (!desktopItem.classList.contains('sap-nav__item')) continue;
      var topLink = directChild(desktopItem, 'sap-nav__link');
      if (!topLink) continue;

      var mobileItem = document.createElement('li');
      mobileItem.className = 'sap-mobile-nav__item';
      var dropdown = directChild(desktopItem, 'sap-nav__dropdown');
      if (!dropdown) {
        mobileItem.appendChild(mobileLink(topLink, 'sap-mobile-nav__link'));
        target.appendChild(mobileItem);
        continue;
      }

      var details = document.createElement('details');
      details.className = 'sap-mobile-nav__details';
      var summary = document.createElement('summary');
      summary.className = 'sap-mobile-nav__summary';
      var label = document.createElement('span');
      label.className = 'sap-mobile-nav__link--parent';
      label.textContent = topLink.textContent.trim();
      var chevron = document.createElement('span');
      chevron.className = 'sap-mobile-nav__chevron';
      chevron.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      summary.appendChild(label);
      summary.appendChild(chevron);
      details.appendChild(summary);

      var subList = document.createElement('ul');
      subList.className = 'sap-mobile-nav__sub-list';
      var products = dropdown.querySelectorAll('.sap-nav__col--products .sap-nav__biglink');
      var collections = dropdown.querySelectorAll('.sap-nav__col--shop .sap-nav__smalllink');
      var articles = dropdown.querySelectorAll('.sap-nav__col--learn .sap-nav__smalllink');
      var hasGroup = appendGroup(
        subList,
        products,
        'sap-mobile-nav__sub-link sap-mobile-nav__sub-link--product',
        false
      );
      hasGroup = appendGroup(
        subList,
        collections,
        'sap-mobile-nav__sub-link sap-mobile-nav__sub-link--collection',
        hasGroup
      ) || hasGroup;
      appendGroup(
        subList,
        articles,
        'sap-mobile-nav__sub-link sap-mobile-nav__sub-link--article',
        hasGroup
      );
      details.appendChild(subList);
      mobileItem.appendChild(details);
      target.appendChild(mobileItem);
    }
    nav.dataset.sapMenuHydrated = '1';
  }

  function setOpen(open) {
    if (open) hydrateMenu();
    nav.classList.toggle('is-open', open);
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('sap-nav-open', open);
    document.querySelectorAll('[data-sap-mobile-toggle]').forEach(function(toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-sap-mobile-toggle]');
    if (toggle) {
      event.preventDefault();
      setOpen(!nav.classList.contains('is-open'));
      return;
    }
    if (event.target.closest('[data-sap-mobile-close]')) setOpen(false);
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sapsan-product-rating"] && !Shopify.designMode) return;
  try {
    /* SAPSAN compact star rating - reusable widget for product page summary and collection cards.
   v2 (2026-05-09): batch endpoint + KV cache (Worker) + localStorage stale-while-revalidate.
   Fallback chain: localStorage(fresh) -> Worker batch -> Fera direct -> empty. */
(function () {
  'use strict';

  var WORKER_BATCH_URL = 'https://sapsan-product-ratings.sapsan-6ea.workers.dev/batch';
  var BATCH_DEBOUNCE_MS = 50;
  var BATCH_MAX_SIZE = 60;
  var LS_PREFIX = 'sapsan_rating_v1:';
  var LS_FRESH_TTL_MS = 60 * 60 * 1000;        // 1h fresh
  var LS_STALE_TTL_MS = 24 * 60 * 60 * 1000;   // 24h hard expiry

  var I18N_REVIEWS = {
    pl: ['recenzja', 'recenzje', 'recenzji'],
    en: ['review', 'reviews', 'reviews'],
    cs: ['recenze', 'recenze', 'recenzí'],
    de: ['Bewertung', 'Bewertungen', 'Bewertungen'],
    ru: ['отзыв', 'отзыва', 'отзывов']
  };

  var locale = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];

  function plural(n) {
    var pack = I18N_REVIEWS[locale] || I18N_REVIEWS.en;
    if (locale === 'pl') {
      if (n === 1) return pack[0];
      var mod10 = n % 10, mod100 = n % 100;
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return pack[1];
      return pack[2];
    }
    if (locale === 'cs') return n === 1 ? pack[0] : (n >= 2 && n <= 4 ? pack[1] : pack[2]);
    if (locale === 'ru') {
      if (n % 10 === 1 && n % 100 !== 11) return pack[0];
      if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) return pack[1];
      return pack[2];
    }
    return n === 1 ? pack[0] : pack[1];
  }

  function stars(rating) {
    var r = Math.round(rating || 0);
    if (r < 0) r = 0; if (r > 5) r = 5;
    return '★★★★★☆☆☆☆☆'.substr(5 - r, 5);
  }

  function lsGet(productId) {
    try {
      var raw = localStorage.getItem(LS_PREFIX + productId);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.t !== 'number') return null;
      var age = Date.now() - parsed.t;
      if (age > LS_STALE_TTL_MS) {
        localStorage.removeItem(LS_PREFIX + productId);
        return null;
      }
      return { rating: parsed.r, ageMs: age };
    } catch (e) { return null; }
  }

  function lsSet(productId, rating) {
    try {
      localStorage.setItem(LS_PREFIX + productId, JSON.stringify({ r: rating, t: Date.now() }));
    } catch (e) {}
  }

  // Per-productId in-memory promise cache (avoids duplicate Promise chains within one pageview).
  var pendingPromises = window.__sapsanProductRatingPromises = window.__sapsanProductRatingPromises || {};

  // Batch queue: { id: {resolvers: [fn,...], apiKey} }
  var batchQueue = {};
  var batchTimer = null;
  var workerHealthy = true;  // flips false on batch failure; falls back to direct Fera

  function enqueueBatch(productId, apiKey) {
    if (!batchQueue[productId]) batchQueue[productId] = { apiKey: apiKey, resolvers: [] };
    var p = new Promise(function (resolve) {
      batchQueue[productId].resolvers.push(resolve);
    });
    if (!batchTimer) batchTimer = setTimeout(flushBatch, BATCH_DEBOUNCE_MS);
    return p;
  }

  function flushBatch() {
    batchTimer = null;
    var keys = Object.keys(batchQueue);
    if (!keys.length) return;
    // Group by apiKey (typically all same on a page; this is defensive)
    var groups = {};
    keys.forEach(function (id) {
      var k = batchQueue[id].apiKey;
      if (!groups[k]) groups[k] = [];
      groups[k].push(id);
    });
    var snapshot = batchQueue;
    batchQueue = {};

    Object.keys(groups).forEach(function (apiKey) {
      var ids = groups[apiKey];
      // Chunk if oversized
      while (ids.length) {
        var chunk = ids.splice(0, BATCH_MAX_SIZE);
        sendChunk(chunk, apiKey, snapshot);
      }
    });
  }

  function sendChunk(ids, apiKey, snapshot) {
    fetch(WORKER_BATCH_URL, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ apiKey: apiKey, productIds: ids })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ratings) throw new Error('bad_payload');
        ids.forEach(function (id) {
          var rating = data.ratings[id] || null;
          if (rating) lsSet(id, rating);
          var entry = snapshot[id];
          if (entry) entry.resolvers.forEach(function (fn) { fn(rating); });
        });
      })
      .catch(function () {
        workerHealthy = false;
        // Fallback: direct Fera per productId
        ids.forEach(function (id) {
          fetchOneFromFera(id, apiKey).then(function (rating) {
            if (rating) lsSet(id, rating);
            var entry = snapshot[id];
            if (entry) entry.resolvers.forEach(function (fn) { fn(rating); });
          });
        });
      });
  }

  function fetchOneFromFera(productId, apiKey) {
    var url = 'https://api.fera.ai/v3/public/reviews?api_key=' + encodeURIComponent(apiKey) +
              '&product.external_id=' + encodeURIComponent(productId) +
              '&page_size=1&state=approved';
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var prod = json && json.data && json.data[0] && json.data[0].product;
        if (prod && prod.rating) return { average: prod.rating.average, count: prod.rating.count };
        if (json && json.meta) return { average: 0, count: json.meta.total_count || 0 };
        return null;
      })
      .catch(function () { return null; });
  }

  function fetchRating(productId, apiKey) {
    if (pendingPromises[productId]) return pendingPromises[productId];
    if (workerHealthy) {
      pendingPromises[productId] = enqueueBatch(productId, apiKey);
    } else {
      pendingPromises[productId] = fetchOneFromFera(productId, apiKey).then(function (r) {
        if (r) lsSet(productId, r);
        return r;
      });
    }
    return pendingPromises[productId];
  }

  function renderRating(el, rating) {
    if (!rating || !rating.count) {
      el.classList.add('sapsan-product-rating--empty');
      return;
    }
    var starsEl = el.querySelector('[data-sapsan-rating-stars]');
    var textEl = el.querySelector('[data-sapsan-rating-text]');
    if (starsEl) starsEl.textContent = stars(rating.average);
    if (textEl) {
      textEl.innerHTML = '<span class="sapsan-product-rating__avg">' + Number(rating.average).toFixed(1) + '</span>' +
        '<span class="sapsan-product-rating__count">(' + rating.count + ' ' + plural(rating.count) + ')</span>';
    }
    el.classList.remove('sapsan-product-rating--empty');
    el.classList.remove('sapsan-product-rating--loading');
    el.classList.add('sapsan-product-rating--loaded');
  }

  function processNode(el) {
    if (el._sapsanRatingDone) return;
    el._sapsanRatingDone = true;
    var productId = el.dataset.productId;
    var apiKey = el.dataset.feraKey;
    if (!productId || !apiKey) {
      el.classList.add('sapsan-product-rating--empty');
      return;
    }

    // Stale-while-revalidate: render from localStorage immediately (if any), fetch fresh in background.
    var cached = lsGet(productId);
    if (cached && cached.rating) {
      renderRating(el, cached.rating);
      if (cached.ageMs < LS_FRESH_TTL_MS) {
        return; // fresh enough; skip network
      }
      // Stale: refresh in background; swap render only if value changed
      fetchRating(productId, apiKey).then(function (rating) {
        if (!rating) return;
        var prev = cached.rating;
        if (prev.average !== rating.average || prev.count !== rating.count) {
          renderRating(el, rating);
        }
      });
      return;
    }

    // No cache: fetch and render when ready
    fetchRating(productId, apiKey).then(function (rating) {
      renderRating(el, rating);
    });
  }

  function processAll() {
    document.querySelectorAll('[data-sapsan-rating]').forEach(processNode);
  }

  function scrollToReviewsHash() {
    if (window.location.hash !== '#sapsan-reviews') return;
    var reviews = document.getElementById('sapsan-reviews');
    if (!reviews) return;
    window.scrollTo({
      top: reviews.getBoundingClientRect().top + window.scrollY,
      behavior: 'instant'
    });
  }

  window.addEventListener('pageshow', function () {
    setTimeout(scrollToReviewsHash, 250);
  }, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  if ('MutationObserver' in window) {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-sapsan-rating]')) processNode(n);
          else if (n.querySelectorAll) n.querySelectorAll('[data-sapsan-rating]').forEach(processNode);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var DEBUG = false;
  function dlog() {
    if (!DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[sticky-atc v2.4]');
    console.log.apply(console, args);
  }

  var config = {
    animationDuration: 350,
    toastDuration: 3000,
    // IntersectionObserver rootMargin — "form uznaj za out-of-view gdy jest ponad 80px nad/pod viewportem"
    // Bufor zabezpiecza przed flickerem gdy form jest przy krawędzi
    observerRootMargin: '-80px 0px -80px 0px'
  };

  var i18n = {
    buttonAdd: {
      en: 'Add to Cart', pl: 'Dodaj do koszyka', de: 'In den Warenkorb',
      cs: 'Přidat do košíku', ru: 'Добавить в корзину', fr: 'Ajouter au panier',
      es: 'Añadir al carrito', it: 'Aggiungi al carrello'
    },
    buttonNotify: {
      en: 'Notify when back', pl: 'Powiadom gdy wróci', de: 'Benachrichtigen',
      cs: 'Upozornit', ru: 'Уведомить', fr: 'Me prévenir',
      es: 'Avísame', it: 'Avvisami'
    },
    notifyFallback: {
      en: 'Scroll up and use the notify form on the product', pl: 'Przewiń w górę i użyj formularza powiadomienia',
      de: 'Nach oben scrollen und Formular verwenden', cs: 'Přejděte nahoru k formuláři',
      ru: 'Прокрутите вверх к форме', fr: 'Défilez vers le haut jusqu\'au formulaire',
      es: 'Desplázate a arriba al formulario', it: 'Scorri su al modulo'
    },
    selectVariant: {
      en: 'Select a variant', pl: 'Wybierz wariant', de: 'Variante auswählen',
      cs: 'Vyberte variantu', ru: 'Выберите вариант', fr: 'Sélectionnez une variante',
      es: 'Selecciona una variante', it: 'Seleziona una variante'
    },
    success: {
      en: 'Added to cart', pl: 'Dodano do koszyka', de: 'In den Warenkorb gelegt',
      cs: 'Přidáno do košíku', ru: 'Добавлено в корзину', fr: 'Ajouté au panier',
      es: 'Añadido al carrito', it: 'Aggiunto al carrello'
    },
    error: {
      en: 'Error adding to cart', pl: 'Błąd podczas dodawania', de: 'Fehler beim Hinzufügen',
      cs: 'Chyba při přidávání', ru: 'Ошибка при добавлении', fr: 'Erreur lors de l\'ajout',
      es: 'Error al añadir', it: 'Errore durante l\'aggiunta'
    }
  };

  function t(key) {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return (i18n[key] && (i18n[key][lang] || i18n[key].en)) || '';
  }

  function sanitizeText(s) { return String(s || '').replace(/[<>"']/g, '').trim(); }
  function sanitizeId(s) { return String(s || '').replace(/[^0-9]/g, ''); }

  var StickyATC = {
    wrapper: null,
    productData: null,
    variantSelect: null,
    isVisible: false,
    isHiding: false,

    init: function() {
      this.wrapper = document.getElementById('sticky-atc-wrapper');
      if (!this.wrapper) return;

      this.setupProductData();
      this.setupEventListeners();
      this.updateContent();
      this.setupVisibilityObserver();
    },

    setupVisibilityObserver: function() {
      // Anchor chain — idzie od najbardziej specyficznego do generycznego.
      // Dla w pełni wyprzedanych produktów formularza /cart/add może nie być — łapiemy wtedy
      // Klaviyo BIS anchor lub sekcję informacji o produkcie (cena, tytuł).
      var anchor = document.querySelector('.product-form--atc-button') ||
                   document.querySelector('button[name="add"]') ||
                   document.querySelector('[data-add-to-cart]') ||
                   document.querySelector('.product-form__submit') ||
                   document.querySelector('.klaviyo-bis-trigger') ||
                   document.querySelector('.klaviyo-btn-sap') ||
                   document.querySelector('.klaviyo-bis-wrapper') ||
                   this.productData.form ||
                   document.querySelector('.product-form--atc') ||
                   document.querySelector('[data-product-form]') ||
                   document.querySelector('.product__price') ||
                   document.querySelector('[class*="product__meta"]') ||
                   document.querySelector('main h1');

      if (!anchor) {
        dlog('no anchor — sticky will not show');
        return;
      }
      dlog('anchor:', anchor);

      var self = this;

      function evaluate() {
        var rect = anchor.getBoundingClientRect();
        // rect.bottom < 0 znaczy że button całkowicie przescrollowany powyżej viewportu
        // Pokaż sticky zawsze (availability obsługuje updateButtonState — "Powiadom gdy wróci")
        if (rect.bottom < 0) {
          self.show();
        } else {
          self.hide();
        }
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.boundingClientRect.bottom < 0) {
              self.show();
            } else {
              self.hide();
            }
          });
        }, { rootMargin: '0px', threshold: [0, 1] });
        observer.observe(anchor);
      }

      // Dodatkowo scroll listener — IO nie odpala się na każdy scroll, tylko przy zmianie intersekcji.
      // Potrzebujemy aktualizacji gdy user scrolluje ciągle powyżej buttona (IO milczy).
      var scrollTimer;
      window.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(evaluate, 80);
      }, { passive: true });

      // Wstępne wywołanie po załadowaniu żeby ustawić start state
      evaluate();
    },

    setupProductData: function() {
      this.productAvailable = this.wrapper.dataset.productAvailable !== 'false';
      this.productData = {
        title: this.getProductTitle(),
        price: this.getProductPrice(),
        image: this.getProductImage(),
        variants: this.getProductVariants(),
        form: document.querySelector('form[action*="/cart/add"]')
      };
    },

    getProductTitle: function() {
      var metaTitle = document.querySelector('meta[property="og:title"]');
      var h1Title = document.querySelector('h1');
      var title = (metaTitle && metaTitle.content) || (h1Title && h1Title.textContent) || 'Product';
      return sanitizeText(title);
    },

    getProductPrice: function() {
      var el = document.querySelector('[class*="price"]:not([class*="compare"])') ||
               document.querySelector('.product__price') ||
               document.querySelector('[data-price]');
      return (el && el.textContent && el.textContent.trim()) || '';
    },

    getProductImage: function() {
      var metaImage = document.querySelector('meta[property="og:image"]');
      var productImage = document.querySelector('.product__media img') ||
                         document.querySelector('[class*="product-image"] img');
      var src = (metaImage && metaImage.content) || (productImage && productImage.src) || '';
      try {
        var u = new URL(src);
        return (u.protocol === 'http:' || u.protocol === 'https:') ? src : '';
      } catch (e) { return ''; }
    },

    getProductVariants: function() {
      // Preferuj window.theme.productVariants (Empire theme) — ma pole available
      if (window.theme && Array.isArray(window.theme.productVariants)) {
        return window.theme.productVariants.map(function(v) {
          return {
            id: String(v.id),
            title: sanitizeText(v.title || v.name || ''),
            available: !!v.available,
            price: v.price
          };
        });
      }

      // Fallback: parsuj z select[name="id"]
      var list = [];
      var sel = document.querySelector('select[name="id"]');
      if (sel && sel.tagName === 'SELECT') {
        Array.prototype.forEach.call(sel.options, function(opt) {
          var cleanId = sanitizeId(opt.value);
          if (!opt.value || cleanId === '') return;
          list.push({
            id: cleanId,
            title: sanitizeText(opt.textContent),
            available: !opt.disabled
          });
        });
      }
      return list;
    },

    hasAnyAvailable: function() {
      return this.productData.variants.some(function(v) { return v.available; });
    },

    getCurrentVariantId: function() {
      var formSel = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (formSel && formSel.value) return sanitizeId(formSel.value);
      var anySel = document.querySelector('[name="id"]');
      return anySel && anySel.value ? sanitizeId(anySel.value) : '';
    },

    getCurrentVariant: function() {
      var id = this.getCurrentVariantId();
      if (!id) return null;
      for (var i = 0; i < this.productData.variants.length; i++) {
        if (String(this.productData.variants[i].id) === String(id)) return this.productData.variants[i];
      }
      return null;
    },

    isCurrentVariantAvailable: function() {
      // Twardy override: jeśli Liquid zwrócił product.available=false → zero dostępnych wariantów.
      if (this.productAvailable === false) return false;
      // Defensive: gdy brak wiarygodnego źródła o availability — zakładaj dostępność,
      // Shopify zwaliduje przy /cart/add.js.
      if (!this.productData.variants || this.productData.variants.length === 0) return true;
      var v = this.getCurrentVariant();
      if (!v) return true;
      return !!v.available;
    },

    setupEventListeners: function() {
      var self = this;

      // Nasłuch na wszystkie możliwe źródła zmiany wariantu
      var selectors = [
        'select[name="id"]', '[name="id"]',
        '.product-form__variant-select', '[data-variant-id]',
        '.product-form__input[type="radio"]', '.single-option-selector',
        '.product-form__option input', 'input[name*="option"]', 'select[name*="option"]'
      ];
      selectors.forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          ['change', 'input', 'click'].forEach(function(evt) {
            el.addEventListener(evt, function() {
              setTimeout(function() { self.handleVariantChange(); }, 150);
            });
          });
        });
      });

      // MutationObserver na zmiany value w select wariantów
      var mainSel = document.querySelector('select[name="id"]');
      if (mainSel) {
        new MutationObserver(function() {
          setTimeout(function() { self.handleVariantChange(); }, 100);
        }).observe(mainSel, { attributes: true, attributeFilter: ['value'] });
      }

      // Observer na price changes
      var priceEl = document.querySelector('.product__price') || document.querySelector('[class*="price"]');
      if (priceEl) {
        new MutationObserver(function() {
          setTimeout(function() { self.updatePrice(); }, 80);
        }).observe(priceEl, { childList: true, subtree: true, characterData: true });
      }

      // Button
      var btn = this.wrapper.querySelector('.sticky-atc-button');
      if (btn) btn.addEventListener('click', function(e) { self.handleAddToCart(e); });

      // Variant select w sticky
      this.variantSelect = this.wrapper.querySelector('.sticky-atc-variant');
      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', function() { self.syncVariantSelection(); });
      }
    },

    handleVariantChange: function() {
      this.updateSelectedVariant();
      this.updatePrice();
      this.updateButtonState();

      // Jeśli sticky widoczny ale aktualny wariant nie-available → ukryj
      if (this.isVisible && !this.isCurrentVariantAvailable()) {
        this.hide();
      }
    },

    updateContent: function() {
      var imgEl = this.wrapper.querySelector('.sticky-atc-image');
      if (imgEl && this.productData.image) {
        imgEl.src = this.productData.image;
        imgEl.alt = this.productData.title;
        imgEl.onerror = function() { this.style.display = 'none'; };
      }

      var titleEl = this.wrapper.querySelector('.sticky-atc-title');
      if (titleEl) titleEl.textContent = this.productData.title;

      this.updatePrice();
      this.updateVariants();
      this.updateButtonState();
    },

    updatePrice: function() {
      var priceEl = this.wrapper.querySelector('.sticky-atc-price');
      if (!priceEl) return;

      var v = this.getCurrentVariant();
      if (v && v.price != null && window.Shopify && typeof Shopify.formatMoney === 'function') {
        priceEl.textContent = Shopify.formatMoney(v.price, (window.theme && window.theme.moneyFormat) || '\u007b\u007bamount\u007d\u007d');
        return;
      }
      priceEl.textContent = this.productData.price || '';
    },

    updateVariants: function() {
      if (!this.variantSelect || this.productData.variants.length <= 1) {
        if (this.variantSelect) this.variantSelect.style.display = 'none';
        return;
      }

      this.variantSelect.innerHTML = '';

      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = t('selectVariant');
      placeholder.disabled = true;
      placeholder.selected = true;
      this.variantSelect.appendChild(placeholder);

      this.productData.variants.forEach(function(v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title + (v.available ? '' : ' —');
        opt.disabled = !v.available;
        this.variantSelect.appendChild(opt);
      }, this);

      this.variantSelect.style.display = 'block';
      this.updateSelectedVariant();
    },

    updateSelectedVariant: function() {
      if (!this.variantSelect) return;
      var id = this.getCurrentVariantId();
      this.variantSelect.value = id || '';
    },

    syncVariantSelection: function() {
      var originalSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]') ||
                           document.querySelector('select[name="id"]');
      if (!originalSelect || !this.variantSelect) return;
      originalSelect.value = this.variantSelect.value;
      originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
    },

    updateButtonState: function() {
      var btn = this.wrapper.querySelector('.sticky-atc-button');
      var txt = this.wrapper.querySelector('.sticky-atc-button-text');
      if (!btn || !txt) return;

      var available = this.isCurrentVariantAvailable();
      if (available) {
        txt.textContent = t('buttonAdd');
        btn.classList.remove('is-notify');
        btn.disabled = false;
        btn.dataset.mode = 'cart';
      } else {
        txt.textContent = t('buttonNotify');
        btn.classList.add('is-notify');
        btn.disabled = false;
        btn.dataset.mode = 'notify';
      }
    },

    handleAddToCart: function(e) {
      e.preventDefault();
      var self = this;

      // Jeśli wariant niedostępny → tryb notify zamiast add-to-cart
      if (!this.isCurrentVariantAvailable()) {
        this.handleNotify();
        return;
      }

      var btn = e.currentTarget;
      var variantId = this.getCurrentVariantId();

      if (!variantId) {
        this.toast(t('selectVariant'), 'warning');
        return;
      }

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(j) { throw new Error(j.description || 'cart_error'); });
          return r.json();
        })
        .then(function() {
          self.toast(t('success'), 'success');
          self.updateCartIcon();
        })
        .catch(function() {
          self.toast(t('error'), 'error');
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = !self.isCurrentVariantAvailable();
        });
    },

    handleNotify: function() {
      // TODO (2026-04-20): gdy Cloudflare Worker + native form będą gotowe,
      // podmienić na bezpośredni POST do Workera. Na razie — triggeruj istniejący
      // Klaviyo BIS anchor (działa dla użytkowników bez adblocka).
      var triggers = [
        '.klaviyo-bis-trigger',
        '.klaviyo-btn-sap',
        '[data-klaviyo-bis]',
        'a[href*="klaviyo"][href*="back"]'
      ];

      for (var i = 0; i < triggers.length; i++) {
        var el = document.querySelector(triggers[i]);
        if (el) {
          // Scroll do elementu + klik po 300ms (żeby user widział formularz się otwierający)
          try {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (e) { /* ignore */ }
          setTimeout(function() { el.click(); }, 350);
          return;
        }
      }

      // Brak oryginalnego BIS trigger'a na stronie — scroll do product form i toast z instrukcją
      var form = this.productData.form;
      if (form) {
        try { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* ignore */ }
      }
      this.toast(t('notifyFallback'), 'warning');
    },

    updateCartIcon: function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var counter = document.querySelector('.site-header-cart--count');
          if (!counter) {
            counter = document.querySelector('[data-header-cart-count], .cart-count, [data-cart-count], .header-cart-count, .cart-counter');
          }
          if (!counter) return;

          if (counter.hasAttribute('data-header-cart-count')) {
            counter.textContent = '';
            counter.setAttribute('data-header-cart-count', cart.item_count > 0 ? cart.item_count : '');
          } else {
            counter.textContent = cart.item_count;
          }
          counter.classList.toggle('visible', cart.item_count > 0);

          // Usuń duplikaty Empire
          var all = document.querySelectorAll('.site-header-cart--count');
          for (var i = 1; i < all.length; i++) {
            if (all[i].parentNode) all[i].parentNode.removeChild(all[i]);
          }
        })
        .catch(function() {});
    },

    toast: function(message, variant) {
      var el = document.createElement('div');
      el.className = 'sticky-atc-toast sticky-atc-toast--' + (variant || 'info');
      el.textContent = message;
      document.body.appendChild(el);
      // eslint-disable-next-line no-unused-expressions
      el.offsetWidth;
      el.classList.add('is-visible');
      setTimeout(function() {
        el.classList.remove('is-visible');
        setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
      }, config.toastDuration);
    },

    show: function() {
      if (this.isVisible || this.isHiding) return;
      this.wrapper.setAttribute('aria-hidden', 'false');
      this.wrapper.classList.add('sticky-atc-visible');
      this.isVisible = true;
      this.isHiding = false;
    },

    hide: function() {
      if (!this.isVisible || this.isHiding) return;
      this.isHiding = true;
      this.wrapper.classList.remove('sticky-atc-visible');
      this.wrapper.setAttribute('aria-hidden', 'true');
      var self = this;
      setTimeout(function() {
        if (self.isHiding) {
          self.isVisible = false;
          self.isHiding = false;
        }
      }, config.animationDuration);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { StickyATC.init(); });
  } else {
    StickyATC.init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
